import React from "react";
import { useHistory } from "react-router";
import { Button, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { PoliciesListSearch } from "../../features/PoliciesListSearch/PoliciesListSearch";
import { PoliciesListTable } from "../../features/PoliciesListTable/PoliciesListTable";
import { hasAccess } from "../../../../components/RolesModule/hasAccess";
import { MENU_ADMIN_OFFERING_POLICY_WRITE } from "../../../../lib/const/permissions";
import "./PoliciesList.less";

export const PoliciesList = () => {
  const history = useHistory();

  return (
    <div className="policies-list">
      <Row justify="space-between">
        <h1>Политики</h1>
        {hasAccess(MENU_ADMIN_OFFERING_POLICY_WRITE) && (
          <Button
            icon={<PlusOutlined />}
            type="primary"
            className="policies-list__add-btn"
            onClick={() => {
              history.push(`/policies/create`);
            }}
          >
            Создать политику
          </Button>
        )}
      </Row>
      <PoliciesListSearch />
      <PoliciesListTable />
    </div>
  );
};
